require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-evolitiegebouw-nioo-knaw.json") })
        }
      }, "path---projecten-evolitiegebouw-nioo-knaw");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-evolitiegebouw-nioo-knaw!./.cache/json/projecten-evolitiegebouw-nioo-knaw.json
// module id = 413
// module chunks = 231608221292675